export default "__VITE_ASSET__d3eb39e2__"